
(function ($) {
  'use strict';

  /* =========================
   *  Utilities
   * ========================= */
  function formatPrice(price) {
    return '$' + parseFloat(price || 0, 10)
      .toFixed(2)
      .replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  }

  function parseCurrency(str) {
    return parseFloat(
      String(str || '').replace(/[^0-9.]/g, '').replace(/[.]{2,}/, '')
    ) || 0;
  }

  // Numeric-only enforcement for qty inputs
  function bindNumericOnly() {
    const selector = 'input.variant-add, input.pack-input, input.quantity-add';

    // Block non-numeric keys while typing
    $(document).off('keydown.numericOnly', selector).on('keydown.numericOnly', selector, function (e) {
      const k = e.key;

      // Allow control/navigation keys
      const ctrlCombo = (e.ctrlKey || e.metaKey) && ['a','c','v','x','A','C','V','X'].includes(k);
      const navKey = ['Backspace','Delete','Tab','Escape','Enter','ArrowLeft','ArrowRight','Home','End'].includes(k);

      if (ctrlCombo || navKey) return;
      if (/^\d$/.test(k)) return; // allow digits 0-9

      e.preventDefault();
    });

    // Sanitize pasted content or IME input
    $(document).off('input.numericOnly', selector).on('input.numericOnly', selector, function () {
      this.value = this.value.replace(/[^\d]/g, '');
    });

    // Helpful hints for mobile keyboards (applies to current DOM)
    $(selector).attr({ inputmode: 'numeric', pattern: '[0-9]*' });
  }

  /* =========================
   *  Focus + Enter-to-add
   * ========================= */
  $(document).off('focus.qtyFocus', '.quantity-add').on('focus.qtyFocus', '.quantity-add', function () {
    const $this = $(this);
    $this.addClass('hasText');

    // Avoid stacking handlers on the same element
    $this.off('keydown.cartEnter').on('keydown.cartEnter', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        const $row = $this.closest('tr');
        $row.find('button').trigger('click');
      }
    });

    $('.quick_cart_table tr').removeClass('_highlight');
    $this.closest('tr').addClass('_highlight');

    $this.closest('tr').find('button').prop('disabled', false);
  });

  /* =========================
   *  Smooth scroll
   * ========================= */
  $(document).off('click.learnMore', '.learn-more').on('click.learnMore', '.learn-more', function (event) {
    event.preventDefault();
    const $target = $('.quick_addto_cart');
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top }, 1000);
    }
  });

  /* =========================
   *  Per-row totals from packs
   * ========================= */
  function updatePackInput() {
    // Bind once via delegation
    if (window.__packInputBound) return;
    window.__packInputBound = true;

    $(document).on('input.packCalc', '.pack-input', function () {
      const $tr = $(this).closest('tr');
      const variantPrice = parseFloat($(this).data('price')) || 0;

      const totalQty = $tr.find('input').toArray().reduce((acc, input) => {
        return acc + (parseInt(input.value, 10) || 0);
      }, 0);

      const totalPrice = totalQty * variantPrice;

      $tr.find('.subtotal-price').text(formatPrice(totalPrice));
      $tr.find('.qty-sum').text(totalQty);

      calcTotal();
    });
  }

  /* =========================
   *  Totals (table/global)
   * ========================= */
  function calcTotal() {
    let totalAmount = 0;
    let sum = 0;

    $('[data-totals]').each(function () {
      const $scope = $(this);
      totalAmount += parseCurrency($scope.find('.subtotal-price').text());
      sum += +$scope.find('.qty-sum').text() || 0;
    });

    $('.sum').text(formatPrice(totalAmount));
    $('.total_count').text(sum);
  }

  // Keep the name but delegate to calcTotal to avoid duplicate logic
  function updateCalcTotal() {
    calcTotal();
  }

  /* =========================
   *  Cart Drawer Triggers
   * ========================= */
  function triggerOpenCartDrawer() {
    const el = document.querySelector('.openCartDrawer');
    if (el) el.click();
  }

  $(document).off('click.cartTrigger', '.cart-trigger').on('click.cartTrigger', '.cart-trigger', function (e) {
    e.preventDefault();
    triggerOpenCartDrawer();
  });

  /* =========================
   *  Add-to-cart flow
   * ========================= */
  $(document).off('click.addToCart', '[data-add-to-cart]').on('click.addToCart', '[data-add-to-cart]', function (e) {
    e.preventDefault();

    const $addToCartButton = $(this);
    const $row = $addToCartButton.closest('tr');
    const variantInputs = $row.find('.variant-add');
    const availableVariants = getAvailableVariants(variantInputs);

    if (availableVariants.length > 0) {
      $addToCartButton.addClass('is-loading');
      addVariantsToCart(availableVariants, $addToCartButton)
        .then(() => updateCartUI($addToCartButton))
        .catch((error) => console.error(error))
        .finally(() => clearInputFields(variantInputs));
    }
  });

  function getAvailableVariants(variantInputs) {
    const availableVariants = [];
    variantInputs.each(function () {
      const qty = parseInt($(this).val(), 10);
      if (qty > 0) {
        const variantId = $(this).data('variant-id');
        availableVariants.push({ id: variantId, quantity: qty });
      }
    });
    return availableVariants;
  }

  function clearInputFieldsAndRecalculateTotals(inputs, $addToCartButton) {
    inputs.each(function () { $(this).val(''); });

    setTimeout(() => {
      clearCalcTotal($addToCartButton);
      triggerOpenCartDrawer();
    }, 1000); // preserve original timing
  }

  function clearCalcTotal($button) {
    const $parent = $button.closest('tr');
    $parent.removeClass('_highlight');
    resetCartUI($parent);
    updateCalcTotal();
  }

  function resetCartUI($parent) {
    const zero = 0;
    $parent.find('.sum, .subtotal-price').text(formatPrice(zero));
    $parent.find('.total_count, .qty-sum').text(zero);
    // Optionally disable the row button here if desired
    // $parent.find('[data-add-to-cart]').prop('disabled', true);
  }

  function addVariantsToCart(variants, $button) {
    const addToCartPromises = variants.map((variant, index) =>
      new Promise((resolve, reject) => {
        setTimeout(() => {
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: `quantity=${variant.quantity}&id=${variant.id}`,
            dataType: 'json',
            success: resolve,
            error: reject
          });
        }, 1000 * index); // preserve original stagger
      })
    );

    return Promise.all(addToCartPromises)
      .then(() => {
        $button.removeClass('is-loading');
        displayFeedbackMessage($button, 'success', 'Added to cart!');
        clearInputFieldsAndRecalculateTotals($button.closest('tr').find('.variant-add'), $button);
      })
      .catch((error) => {
        console.log('Fail:', error);
        const msg = (error && error.responseJSON && error.responseJSON.description) ? error.responseJSON.description : 'Failed to add to cart.';
        displayFeedbackMessage($button, 'error', msg);
        $button.removeClass('is-loading');
        clearInputFieldsAndRecalculateTotals($button.closest('tr').find('.variant-add'), $button);
      });
  }

  function clearInputFields(inputs) {
    inputs.val('');
  }

  function updateCartUI($button) {
    $.getJSON('/cart.js', function (cart) {
      console.log(`There are now ${cart.item_count} items in the cart.`);
      $button.removeClass('is-loading');

      if (cart.item_count > 0) {
        displayFeedbackMessage($button, 'success', 'Added to cart!');
        setTimeout(() => $('.ajaxified-cart-feedback').remove(), 3000);
      }
    }).fail(function (jqXHR, textStatus, error) {
      console.error('Error fetching cart details:', textStatus, error);
      displayFeedbackMessage($button, 'error', 'Failed to update cart.');
      setTimeout(() => $('.ajaxified-cart-feedback').remove(), 3000);
    });
  }

  function displayFeedbackMessage($element, type, message) {
    const feedbackClass = 'ajaxified-cart-feedback';
    const className = `${feedbackClass} ${type}`;
    // If you want only one message at a time near the button, uncomment next line:
    // $element.siblings(`.${feedbackClass}`).remove();
    $element.after(`<p class="${className}">${message}</p>`);
  }

  /* =========================
   *  Init
   * ========================= */
  $(function () {
    bindNumericOnly();
    updatePackInput(); // attaches delegated handler
  });

})(jQuery);

